import NewInput from 'app/components/NewInput';
import Button from 'app/components/button';
import { Modal } from 'react-bootstrap';
import { RxCross2 } from 'react-icons/rx';

// Presentational copy of the password prompt used by the Vouchers tab, so the
// Packages tab prompt looks identical (REQ-01). No API calls and no state: the
// caller owns the value and decides what a correct password unlocks.
export const PasswordPromptModal = ({
  show,
  value,
  onChange,
  onSubmit,
  onClose,
}) => (
  <Modal
    size='sm'
    show={show}
    onHide={onClose}
    aria-labelledby='delete-popup'
    centered
  >
    <div className='cursor-pointer'>
      <span className='close-icon' onClick={onClose}>
        <RxCross2 />
      </span>
    </div>
    <Modal.Body className='text-center d-flex justify-content-around mt-5'>
      <div className='modal-image-form'>
        <NewInput
          label='Password*'
          type='text'
          placeholder='Enter Password'
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && value) onSubmit();
          }}
        />
        <Button
          className='mt1 button ms-2'
          onClick={onSubmit}
          variant='Submit'
          name='Submit'
          isDisabled={!value}
        />
      </div>
    </Modal.Body>
  </Modal>
);

export default PasswordPromptModal;
